import React, { useContext } from "react";
import shield from "assets/shield.png";
import { BreakpointContext } from "components/common";

export const VerificationExplanation = () => {
  const { isBelow } = useContext(BreakpointContext);

  return (
    <div className="flex md:flex-col">
      <img
        src={shield}
        alt="shield"
        style={{
          width: isBelow("md") ? 24 : 40,
          height: isBelow("md") ? 24 : 40,
          marginTop: isBelow("md") ? 12 : 0,
        }}
      />
      <p className="text-lg font-medium hidden md:flex md:mt-2">
        Why do you need my info?
      </p>
      <p className="mt-2 ml-2 md:ml-0">
        Your information helps us securely retrieve your credit score so that we
        can make personalized recommendation to monitor and improve your credit.
      </p>
    </div>
  );
};
